import React from "react";
import { debounce } from "lodash";
import { store } from "../../../store/store";
import { Easing, Animated, View } from "react-native";
import { View as AnimatableView } from "react-native-animatable"

import { getCartTotalItemCount } from "../../services/oms/UpsertCartData";

import { IconView } from "../CommonWidget/Icons";
import { CartItemCountView } from "../CommonWidget/CartIconView";

import AppTheme from "../../../AppTheme";

class CartIconAnimation extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            isCartTabActive: props.isActive,
            cartItemCount: getCartTotalItemCount()
        };
    }

    spinValue = new Animated.Value(0)
    spinAnimation = Animated.timing(
        this.spinValue, {
        toValue: 1, duration: AppTheme.animationDuration,
        easing: Easing.linear, useNativeDriver: true
    })

    startAnimation = () => {
        this.spinAnimation.start()
        setTimeout(() => this.resetCartAnimation(), AppTheme.animationDuration)
    }

    resetCartAnimation = () => { this.spinAnimation.reset() }

    getCartItemCount = () => {
        var itemCount = getCartTotalItemCount()
        if (this.state.cartItemCount < itemCount &&
            !this.spinValue['_value']) this.animationDebounce()
        this.setState({ cartItemCount: itemCount })
    }

    animationDebounce = debounce(this.startAnimation, AppTheme.debouceTimeout)
    itemCountSubscription = debounce(this.getCartItemCount, AppTheme.debouceTimeout)

    componentDidMount() {
        this.itemCountSubscription()
        store.subscribe(() => this.itemCountSubscription())
    }

    getCartAnimationDegree = (animationValue) => {
        return animationValue.interpolate({
            inputRange: [0, 0.25, 0.5, 0.75, 1],
            outputRange: ['0deg', '-30deg', '0deg', '30deg', '0deg']
        })
    }

    render() {
        return <View style={{ alignItems: "center" }}>
            {this.state.cartItemCount ? <AnimatableView
                style={{ transform: [{ rotate: this.getCartAnimationDegree(this.spinValue) }] }}>
                <IconView width={20} height={16} iconPath={this.state.isCartTabActive ?
                    '/images/navBar/cart_blue.svg' : '/images/navBar/cart_grey.svg'} />
                <CartItemCountView cartCount={this.state.cartItemCount} />
            </AnimatableView> : <IconView width={20} height={16} iconPath={this.state.isCartTabActive ?
                '/images/navBar/cart_blue.svg' : '/images/navBar/cart_grey.svg'} />}
        </View >
    }
}

export default CartIconAnimation
